(function () {
  'use strict';

  angular
    .module('productivity-indicators')
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('root.productivity-indicators', {
      url: '/productivity-indicators?vfiltro',
      views: {
        'content@': {
          templateUrl: 'productivity-indicators/productivity-indicators.tpl.html',
          controller: 'ProductivityIndicatorsCtrl',
          controllerAs: 'productivityIndicatorsCtrl'
        }
      },
      data: {
        titulo: 'ce.indicadores.productivityIndicators.menuLabel',
        hideTitulo: true,
        role: 'ROTA_VISUALIZAR'
      }
    });
  }
}());
